import { render, staticRenderFns } from "./TicketDefectsForm.vue?vue&type=template&id=9d626924&"
import script from "./TicketDefectsForm.vue?vue&type=script&lang=js&"
export * from "./TicketDefectsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports